/**
 * i18n constants.
 *
 * This module deliberately has ZERO imports. `languageStorage.js` needs the
 * supported-language list to validate what it reads out of localStorage, and
 * `index.js` needs that same validated value to initialise i18next — putting
 * these constants in `index.js` would make storage import the i18next instance
 * that is still mid-initialisation. Keeping them here breaks that cycle.
 */

// The language a first-time visitor sees. German, because the product's users
// are German-speaking; a hard default (rather than navigator sniffing) means a
// German customer on an en-US Windows image still lands in German.
export const DEFAULT_LANGUAGE = 'de';

// The language keys are authored in, and therefore the fallback. Note this is
// intentionally NOT the same as DEFAULT_LANGUAGE: a key that has not been
// translated into German yet surfaces as readable English rather than as a raw
// dotted key like "kpi.leadTime.title". That property is what makes migrating
// domain-by-domain safe — a half-migrated UI degrades to English, never to
// visible key names.
export const FALLBACK_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGES = ['de', 'en'];

// BCP 47 tags for Intl.* consumers (number/date formatting). Separate from the
// i18next language code because those are ours to choose ('de'/'en') while
// Intl needs a region to pick separators and date order.
export const INTL_LOCALE_BY_LANGUAGE = {
  de: 'de-DE',
  en: 'en-US',
};
